export interface SpreadsheetImportFailure {
  row?: number
  code?: string
  message: string
}

export interface SpreadsheetImportResult {
  imported: number
  skipped: number
  failures: SpreadsheetImportFailure[]
}

export function normalizeImportFailures(raw: unknown): SpreadsheetImportFailure[] {
  if (raw && typeof raw === "object" && !Array.isArray(raw)) {
    const body = raw as Record<string, unknown>
    return normalizeImportFailures(body.failures ?? body.errors ?? body.failed ?? body.failedRows)
  }
  if (!Array.isArray(raw)) return []

  return raw.flatMap((item, index) => {
    if (typeof item === "string") {
      const message = item.trim()
      return message ? [{ message }] : []
    }
    if (!item || typeof item !== "object") return []
    const row = item as Record<string, unknown>
    const message = String(row.message ?? row.error ?? row.reason ?? row.detail ?? "").trim()
    if (!message) return []
    const code = row.code ?? row.cstcde ?? row.jobCode
    const rowNum = row.row ?? row.line ?? row.index
    return [{
      row: rowNum != null && Number(rowNum) > 0 ? Number(rowNum) : index + 1,
      code: code != null && String(code).trim() ? String(code) : undefined,
      message,
    }]
  })
}
